import { BaseModel } from './BaseModel';

export interface ILibraryModuleModelProps {
    id?: string;
    // userName: string;
    // certificateLink: string;
    // certificateName: string;
    moduleName: string;
    dateCreated: string;
    category: string;
    requestDate: string;
    status: string;
    organizationName: string
    moduleId: string;
    uniqueId: string;
    requestId: string;
}


export class LibraryModuleModel extends BaseModel<ILibraryModuleModelProps> {
    constructor(props: ILibraryModuleModelProps) {
        super(props);
    }

    public static get(id: string) {
        return LibraryModuleModel.getSingleInstance<ILibraryModuleModelProps>(id);
    }

    public static list() {
        return LibraryModuleModel.listAll<ILibraryModuleModelProps>();
    }
    public static resource: string = 'librarymodule';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/LibraryModel.ts